import CustomText from "components/typography/CustomText";
import React from "react";

export default function LabelControl({ label = "", control = "" }) {
  return (
    <div>
      <CustomText className="mb-2" variant="body2" color="inherit" bold={600}>
        {label ?? ""}
      </CustomText>
      {control}
    </div>
  );
}
